<span class="tag" [ngClass]="'tag--' + color">
  <app-icon [icon]="icon" *ngIf="icon" class="mr-2"></app-icon>
  <span class="text-nowrap">{{ label }}</span>
</span>
